import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { baseURL } from '../../../../Apiservices/Api';
import Navbar from "../../../../Shared/ManagerNavbar/Navbar";
import { ThemeContext } from "../../../../Shared/Themes/ThemeContext";
import DataTable from "../../../../Layout/Table/TableLayout";
import "../Mypayments.css";
import { FaEdit, FaTrash } from "react-icons/fa"; 

const M_MyHistoryPage = () => {
  const { supplierId } = useParams();
  const [history, setHistory] = useState([]);
  const location = useLocation();
  // const supplier = location.state?.supplier;
  const [supplierData, setSupplierData] = useState(location.state?.supplier || {});
  const [collapsed, setCollapsed] = useState(false);
  const { themeColor } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [isEditingAmount, setIsEditingAmount] = useState(false);
const [editedAmount, setEditedAmount] = useState(supplierData?.total_payable || 0);


  const fetchPaymentLog = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/payment-log-history`, {
        params: {
          supplier_id: supplierId,
        },
      });
      setHistory(response.data.data);
      console.log("dtaa", response.data.data)
    } catch (err) {
      console.error('Error fetching payment log:', err);

    }
  };

  useEffect(() => {
    if (!supplierId) return;
    fetchPaymentLog();
  }, [supplierId]);

  const handleDelete = async (paymentId) => {
    if (!window.confirm("Are you sure you want to delete this payment?")) {
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/supplier-payments/${paymentId}`, {
        method: "DELETE",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to delete payment");
      }

      alert("Payment deleted successfully");
      fetchPaymentLog();
      // Optional: refresh the list or navigate
      // e.g., fetchPayments(); or remove from local state
    } catch (error) {
      console.error("Delete error:", error);
      alert("Error deleting payment: " + error.message);
    }
  };
 

  const handleSaveAmount = async () => {
    if (!supplierId) {
      alert("No supplier selected");
      return;
    }
  
    try {
      const response = await axios.put(`${baseURL}/api/Total-amount/${supplierId}`, {
        total_payable: editedAmount
      });
  
      if (response.data.success) {
        alert("Total payable amount updated successfully");
        setIsEditingAmount(false);
  
        const newBalance = editedAmount - totals.totalAmount;
  
        // Update local supplierData state
        const updatedSupplier = {
          ...supplierData,
          total_payable: editedAmount,
          balance_payment: newBalance.toFixed(2)
        };
  
        setSupplierData(updatedSupplier);
  
        // Optionally update history state too if needed
        navigate(location.pathname, {
          state: {
            ...location.state,
            supplier: updatedSupplier
          },
          replace: true
        });
      } else {
        throw new Error(response.data.message || "Failed to update amount");
      }
    } catch (error) {
      console.error("Error updating total payable:", error);
      alert("Error updating amount: " + error.message);
      setIsEditingAmount(false);
    }
  };
  

  const columns = [
    {
      Header: "S.No",
      accessor: (_, rowIndex) => rowIndex + 1,
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "Amount",
      accessor: "paid_amount",
      Cell: ({ row }) => `₹${row.original.paid_amount}`
    },
    {
      Header: "Paid On",
      accessor: (row) => {
        const date = new Date(row.paid_on);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();
       

        return `${day}/${month}/${year} `;
      }
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <span className={`status-badge ${row.original.status === 'Approved' ? 'approved' : 'pending'}`}>
          {row.original.status}
        </span>
      )
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => navigate(`/m-edit-mysuppayment/${row.original.id}`)}
          />
          <FaTrash
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => handleDelete(row.original.id)}
          />
        </div>
      ),
    }
    // { 
    //   Header: "Next Payment", 
    //   accessor: "next_payment",
    //   Cell: ({ row }) => row.original.next_payment || 'N/A'
    // }
  ];

  // Calculate totals
  const totals = history.reduce(
    (acc, curr) => {
      acc.totalAmount += Number(curr.paid_amount || 0);
      acc.approvedCount += curr.status === 'Approved' ? 1 : 0;
      return acc;
    },
    { totalAmount: 0, approvedCount: 0 }
  );

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? 'collapsed' : ''}`}>
        <div className="addpayment-form-container">
          <h2 className="" style={{ "--theme-color": themeColor }}>
            Transaction History
          </h2>

          {/* Totals Summary */}
          <div className="totals-summary" style={{
            margin: "20px 0",
            backgroundColor: "#f9f9f9",
            border: "1px solid #ddd",
            padding: "15px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "space-around",
            // fontWeight: "bold"
          }}>
            <strong><span>Supplier Name: {supplierData?.supplier_name || "N/A"}</span></strong>
            <strong>
  <span>
    Total Amount: ₹{" "}
    {isEditingAmount ? (
      <>
        <input
          type="number"
          value={editedAmount}
          onChange={(e) => setEditedAmount(e.target.value)}
          style={{ width: "100px", marginRight: "5px" }}
        />
        <button
          onClick={handleSaveAmount}
          style={{ background: "none", border: "none", cursor: "pointer" }}
          title="Save"
        >
          <i className="fas fa-check" style={{ color: "green" }}></i>
        </button>
        <button
          onClick={() => setIsEditingAmount(false)}
          style={{ background: "none", border: "none", cursor: "pointer" }}
          title="Cancel"
        >
          <i className="fas fa-times" style={{ color: "red" }}></i>
        </button>
      </>
    ) : (
      <>
        {supplierData?.total_payable || "N/A"}
        <button
          onClick={() => {
            setEditedAmount(supplierData?.total_payable || 0);
            setIsEditingAmount(true);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            marginLeft: "10px",
          }}
          title="Edit"
        >
          <i className="fas fa-edit"></i>
        </button>
      </>
    )}
  </span>
</strong>

            <strong><span>Total Transactions: {history.length}</span></strong>
            <strong><span>Total Paid Amount: ₹{totals.totalAmount.toFixed(2)}</span></strong>
            <strong><span>Balance Amount: ₹{supplierData?.balance_payment || "N/A"}</span></strong>
            <strong><span>Approved Transactions: {totals.approvedCount}</span></strong>
          </div>

          {history.length === 0 ? (
            <p className="no-history-text">No transaction history found.</p>
          ) : (
            <DataTable
              columns={columns}
              data={history}
              className="transaction-history-table"
            />
          )}
           <div className="addpayment-form-footer">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => navigate(-1)}
                // disabled={loading} 
              >
                Back
              </button>
              </div>
        </div>
      </div>
    </div>
  );
};

export default M_MyHistoryPage;

// const M_MyHistoryPage = () => {
//   const { supplierId } = useParams();
//   const [history, setHistory] = useState([]);
//   const location = useLocation();
//   const supplier = location.state?.supplier;
//   const [collapsed, setCollapsed] = useState(false);
//   const { themeColor } = useContext(ThemeContext);

//   useEffect(() => {
//     const fetchHistory = async () => {
//       try {
//         const res = await axios.get(`${baseURL}/api/suppliers/${supplierId}/history`);
//         setHistory(res.data);
//       } catch (err) {
//         console.error('Error fetching history:', err);
//       }
//     };

//     fetchHistory();
//   }, [supplierId]);

//   const columns = [
//     {
//       Header: "S.No",
//       accessor: (_, rowIndex) => rowIndex + 1,
//       Cell: ({ row }) => row.index + 1,
//     },
//     { 
//       Header: "Amount", 
//       accessor: "paid_amount",
//       Cell: ({ row }) => `₹${row.original.paid_amount}`
//     },
//     {
//       Header: "Paid On",
//       accessor: (row) => {
//         const date = new Date(row.paid_on);
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
//         const year = date.getFullYear();
//         const hours = String(date.getHours()).padStart(2, "0");
//         const minutes = String(date.getMinutes()).padStart(2, "0");
    
//         return `${day}/${month}/${year} ${hours}:${minutes}`;
//       }
//     }, 
//     { 
//       Header: "Status", 
//       accessor: "status",
//       Cell: ({ row }) => (
//         <span className={`status-badge ${row.original.status === 'Approved' ? 'approved' : 'pending'}`}>
//           {row.original.status}
//         </span>
//       )
//     },
//     // { 
//     //   Header: "Next Payment", 
//     //   accessor: "next_payment",
//     //   Cell: ({ row }) => row.original.next_payment || 'N/A'
//     // }
//   ];

//   // Calculate totals
//   const totals = history.reduce(
//     (acc, curr) => {
//       acc.totalAmount += Number(curr.paid_amount || 0);
//       acc.approvedCount += curr.status === 'Approved' ? 1 : 0;
//       return acc;
//     },
//     { totalAmount: 0, approvedCount: 0 }
//   );

//   return (
//     <div className="salesViewLeadsContainer">
//       <Navbar onToggleSidebar={setCollapsed} />
//       <div className={`salesViewLeads ${collapsed ? 'collapsed' : ''}`}>
//         <div className="addpayment-form-container">
//           <h2 className="" style={{ "--theme-color": themeColor }}>
//             Transaction History
//           </h2>

//           {/* Totals Summary */}
//           <div className="totals-summary" style={{
//             margin: "20px 0",
//             backgroundColor: "#f9f9f9",
//             border: "1px solid #ddd",
//             padding: "15px",
//             borderRadius: "8px",
//             display: "flex",
//             justifyContent: "space-around",
//             // fontWeight: "bold"
//           }}>
//             <strong><span>Supplier Name: {supplier?.supplier_name || "N/A"}</span></strong>
//             <strong><span>Total Transactions: {history.length}</span></strong>
//             <strong><span>Total Amount: ₹{totals.totalAmount.toFixed(2)}</span></strong>
//             <strong><span>Balance Amount: ₹{supplier?.balance_payment || "N/A"}</span></strong>
//             <strong><span>Approved Transactions: {totals.approvedCount}</span></strong>
//           </div>

//           {history.length === 0 ? (
//             <p className="no-history-text">No transaction history found.</p>
//           ) : (
//             <DataTable 
//               columns={columns} 
//               data={history} 
//               className="transaction-history-table"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default M_MyHistoryPage;